import { isPlainObject } from 'lodash'

import { fetchingAPI, apiService } from '@/api'
import { toast } from '@/components/toasts/toast.helpers'

import * as redux from './userSettings.redux'

export const fetchUserSettings = () => async (dispatch) => {
  dispatch(redux.setLoading(true))

  try {
    const response = await fetchingAPI(
      `${apiService.core}/api/cloud_user_settings`,
      'GET',
      dispatch,
      undefined,
      undefined,
      { isSilent: true },
      true
    )

    if (isPlainObject(response.settings)) {
      dispatch(redux.setSettings(response.settings))
    }
  } catch (err) {
    console.error(err)
  } finally {
    dispatch(redux.setLoading(false))
  }
}

// Consumers must skip dispatching while `saving` is true — serialized saves are
// what keep a stale response or rollback from clobbering a newer optimistic value
export const saveUserSetting = (accessor, value) => async (dispatch, getState) => {
  const previousValue = getState().userSettings.settings[accessor]

  dispatch(redux.setSaving(true))
  dispatch(redux.setSetting({ accessor, value }))

  try {
    const response = await fetchingAPI(
      `${apiService.core}/api/cloud_user_settings`,
      'PATCH',
      dispatch,
      JSON.stringify({ settings: { [accessor]: value } }),
      undefined,
      { isSilent: true },
      true
    )

    if (isPlainObject(response.settings)) {
      dispatch(redux.setSettings(response.settings))
    }
  } catch (err) {
    dispatch(redux.setSetting({ accessor, value: previousValue }))
    toast.error('Failed to save your settings', { cause: err })
  } finally {
    dispatch(redux.setSaving(false))
  }
}
